import React from 'react';
import { UniversalSurfaceRenderer } from '../../../platform/UniversalSurfaceRenderer';
import { OverlayHandle } from '../../canvas/overlay/Overlay';
import { OverlayManager } from '../../canvas/overlay/OverlayManager';
import { ContainerScope, resolve } from '../../Container';

// var canvas = document.getElementById("canvas");
// var ctx = canvas.getContext("2d");
// var particlesOnScreen = 245;
// var particlesArray = [];
// var w,h;
// w = canvas.width = window.innerWidth;
// h = canvas.height = window.innerHeight;

const random = (min: number, max: number) => min + Math.random() * (max - min + 1);

export class XmasSnowfall extends React.Component {

    public static contextType = ContainerScope;

    @resolve(OverlayManager) private overlays: OverlayManager;

    private handle = null as OverlayHandle;
    private particles = [] as any[];

    public render = () => null;

    public componentDidMount() {
        this.handle = this.overlays.createOverlay('snow', this.onLayout, this.onPaint);
        this.overlays.add(this.handle);

        for (let i = 0; i < 245; i++) {
            this.particles.push({
                x: Math.random() * window.innerWidth,
                y: Math.random() * window.innerHeight,
                opacity: Math.random(),
                speedX: random(-150, 150),
                speedY: random(100, 300),
                radius: random(0.5, 4.2),
            });
        }

        const frame = () => {
            if (!this.handle) return;
            this.handle.invalidate(true, true);
            requestAnimationFrame(frame);
        };

        frame();
    }

    public componentWillUnmount() {
        this.overlays.remove(this.handle);
    }

    private onLayout = (dt: number) => {
        for (const p of this.particles) {
            p.x += p.speedX * dt;
            p.y += p.speedY * dt;
            if (p.y > window.innerHeight) {
                p.x = Math.random() * window.innerWidth * 1.5;
                p.y = -50;
            }
        }
    };

    private onPaint = (gfx: UniversalSurfaceRenderer) => {
        for (const p of this.particles) {
            const g = gfx.createRadialGradient(p.x, p.y, 0, p.x, p.y, p.radius);
            g.addColorStop(0, 'rgba(210, 236, 242,' + p.opacity + ')');  // white
            g.addColorStop(.8, 'rgba(210, 236, 242,' + p.opacity + ')');  // bluish
            g.addColorStop(1, 'rgba(237, 247, 249,' + p.opacity + ')');   // lighter bluish
            gfx.beginPath();
            gfx.arc(p.x, p.y, p.radius, 0, Math.PI * 2, false);
            gfx.fillStyle = g;
            gfx.fill();
        }
    };
}
